<div *ngIf="!value && value !== 0" class="crm-field-info-edit">
  <mat-icon class="crm-field-info-edit__icon">error_outline</mat-icon>
  <div>{{fieldName}} field is missing. Please update it in the CRM.</div>
</div>
